export default "__VITE_ASSET__3tgbq6n0__"